
import { Vue } from "vue-class-component"; // 基本需要
import {
  dispatchGetGamesDate,
  dispatchGetGamesSubscription,
  dispatchGetProjects,
  dispatchGetGamesData,
  dispatchGetHokIcon,
  dispatchGetHokIn,
  dispatchGetHokOut,
  dispatchGetHokInSkinTrend,
  dispatchGetHokOutSkinTrend,
  dispatchGetHokDeviceList,
  dispatchGetHokDeviceOutList,
} from "@/store/project/actions";
import * as echarts from "echarts";
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
} from "@/store/project/getters";
import { dispatchUploadGamesReportImage } from "@/store/performance/actions";
import { readUserProfile } from "@/store/main/getters";
import {
  readtestGamesDate,
  readtestGamesData,
  readtestDeviceOutList,
  readhokOutSkinTrend,
  readtesthokIcon,
  readtesthokIn,
  readtesthokOut,
  readhokInSkinTrend,
  readtestDeviceList,
} from "@/store/project/getters";
import { dateConversion } from "@/utils"; //类型
import { store } from "@/store";
import { getLocalProject } from "@/utils";
import "@/assets/iconfont/font_3410179_5uqi6h3hn2r/iconfont.css"; //引入仓库
export default class GamesNew extends Vue {
  public localProject = 32;
  public get hokIcon() {
    return readtesthokIcon(store);
  }
  public get hokOutData() {
    return readtesthokOut(store);
  }
  public kingAction = [
    { label: "进场", value: "come" },
    { label: "站定", value: "idle" },
  ];
  public target_index = "";
  public action = "";
  public get hok_in_trend_data() {
    return readhokInSkinTrend(store);
  }
  public get hok_out_trend_data() {
    return readhokOutSkinTrend(store);
  }
  public async deviceInChange() {
    this.inside_trend_loading = true;
    await dispatchGetHokInSkinTrend(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      device_id: this.device_in,
      quality: this.device_list.filter((v) => v.id == this.device_in)[0]
        .quality,
    });
    this.drawInSide();
    this.inside_trend_loading = false;
  }
  public async deviceOutChange() {
    this.out_trend_loading = true;
    await dispatchGetHokOutSkinTrend(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      action: this.action,
      device_id: this.device_out,
      quality: this.device_out_list.filter((v) => v.id == this.device_out)[0]
        .quality,
    });
    this.drawOut();
    this.out_trend_loading = false;
  }
  public device_out = "";
  public device_in = "";
  public actionChange() {
    this.hok_out_trend();
  }
  public target_types = [
    "avg_cpu",
    "avg_fps",
    "avg_pss",
    "avg_vss",
    "gpu_usage",
    "max_pss",
    "max_vss",
    "min_fps",
    "var_fps",
  ];
  public get device_list() {
    return readtestDeviceList(store).device_list;
  }
  public get device_out_list() {
    return readtestDeviceOutList(store).device_list;
  }
  public hokinsideChange() {
    this.drawInSide();
  }
  public hokoutChange() {
    this.drawOut();
  }
  public target_index_out = "";
  public expandCheck(data) {
    data.check = !data.check;
    if (!data.check) {
      let list = [];
      let addData = this.hokinData[data.model].filter((v) => v.level != 0);

      addData.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
        });
      });
      let index = this.hok_inside_table.findIndex(
        (v) => v.model == data.model && v.data.time == data.time
      );
      if (index !== -1) {
        // 确保找到了索引
        this.hok_inside_table.splice(index + 1, 0, ...list);
      }
    } else {
      this.hok_inside_table = this.hok_inside_table.filter(
        (item) => !(item.model === data.model && item.data.level === 1)
      );
    }
  }
  public expandCheckOut(data) {
    data.check = !data.check;
    if (!data.check) {
      let list = [];
      let addData = this.hokOutData[data.model][data.action].filter(
        (v) => v.level != 0
      );

      addData.forEach((v) => {
        list.push({
          model: data.model,
          action: data.action,
          data: v,
        });
      });
      let index = this.hok_out_table.findIndex(
        (v) =>
          v.model == data.model &&
          v.data.time == data.time &&
          v.action == data.action
      );
      if (index !== -1) {
        // 确保找到了索引
        this.hok_out_table.splice(index + 1, 0, ...list);
      }
    } else {
      this.hok_out_table = this.hok_out_table.filter(
        (item) =>
          !(
            item.model === data.model &&
            item.data.level === 1 &&
            item.action == data.action
          )
      );
    }
  }
  public extractBracketContents(input) {
    const regex = /(.+?)(（.+?）)/;
    const matches = input.match(regex);

    if (matches) {
      const textOutsideBrackets = matches[1];
      const textInsideBrackets = matches[2];
      return { textOutsideBrackets, textInsideBrackets };
    } else {
      console.log("未找到匹配的括号内容。");
      return null;
    }
  }
  public mergeCells1({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.hok_inside_table.filter(
        (item) => item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.hok_inside_table.findIndex(
            (item) => item.model === row.model
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public mergeCells({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.hok_out_table.filter(
        (item) => item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.hok_out_table.findIndex((item) => item.model === row.model) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 1) {
      const rowCount = this.hok_out_table.filter(
        (item) => item.action === row.action && item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.hok_out_table.findIndex(
            (item) => item.action === row.action && item.model === row.model
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public checkHok = true;
  public hero_id = "";
  public skin_icon = "";
  public skin_id = "";
  public skin_name = "";
  public hero_name = "";
  public hok_inside_table = [];
  public hok_out_table = [];
  public get hokinData() {
    return readtesthokIn(store);
  }
  public drawInSide() {
    let data = [];
    this.hok_in_trend_data?.device_names.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        data: this.hok_in_trend_data.series[index].map(
          (v) => v[this.target_index]
        ),

        symbol: "circle", //拐点设置为实心
        symbolSize: 8, // 调整数据点大小
        itemStyle: {
          normal: {
            lineStyle: {
              width: 4, // 设置线宽
            },

            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
              color: "#fff", //
            },
            color: "#4ED8DA", //
          },
        },
      });
    });
    let performance_line: any = document.getElementById("skin_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      backgroundColor: "#393E44", // 设置背景色
      tooltip: {
        trigger: "axis",
        confine: true,
        textStyle: {
          color: "#fff", // 文字颜色为白色
        },
        backgroundColor: "#2D3136", // 半透明黑色,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        textStyle: {
          color: "#fff", // 设置legend文字颜色
        },
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置yAxis文字颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#606469",
          },
        },
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.hok_in_trend_data.x_axis,
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置xAxis文字颜色
          },
        },
        axisLine: {
          lineStyle: {
            color: "#606469", // 修改 X 轴颜色
          },
        },
      },

      series: data,
    });
  }
  public drawOut() {
    let data = [];
    this.hok_out_trend_data?.device_names.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        data: this.hok_out_trend_data.series[index].map(
          (v) => v[this.target_index_out]
        ),

        symbol: "circle", //拐点设置为实心
        symbolSize: 8, // 调整数据点大小
        itemStyle: {
          normal: {
            lineStyle: {
              width: 4, // 设置线宽
            },

            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
              color: "#fff", //
            },
            color: "#4ED8DA", //
          },
        },
      });
    });
    let performance_line: any = document.getElementById("skin_out");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      backgroundColor: "#393E44", // 设置背景色
      tooltip: {
        trigger: "axis",
        confine: true,
        textStyle: {
          color: "#fff", // 文字颜色为白色
        },
        backgroundColor: "#2D3136", // 半透明黑色,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        textStyle: {
          color: "#fff", // 设置legend文字颜色
        },
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置yAxis文字颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#606469",
          },
        },
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.hok_out_trend_data.x_axis,
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置xAxis文字颜色
          },
        },
        axisLine: {
          lineStyle: {
            color: "#606469", // 修改 X 轴颜色
          },
        },
      },

      series: data,
    });
  }
  public hokInSide() {
    let data = readtesthokIn(store);
    this.hok_inside_table = [];
    for (let i in data) {
      let show = data[i].length > 1 ? true : false;
      data[i].forEach((v) => {
        if (v.level == 0) {
          this.hok_inside_table.push({
            model: i,
            data: v,
            check: true,
            show: show,
          });
        }
      });
    }
  }
  public hokInOut() {
    let data = readtesthokOut(store);
    this.hok_out_table = [];
    for (let i in data) {
      for (let n in data[i]) {
        let show = data[i][n].length > 1 ? true : false;
        data[i][n].forEach((v) => {
          if (v.level == 0) {
            this.hok_out_table.push({
              model: i,
              action: n,
              data: v,
              check: true,
              show: show,
            });
          }
        });
      }
    }
  }
  public inside_loading = true;
  public out_loading = true;
  public inside_trend_loading = true;
  public out_trend_loading = true;
  public async confirm() {
    this.checkHok = true;
    this.inside_loading = true;
    this.out_loading = true;
    this.inside_trend_loading = true;
    this.out_trend_loading = true;
    this.hero_name = this.hokIcon.hero_list.filter(
      (v) => v.hero_id == this.hero_id
    )[0].hero_name;
    this.skin_icon = this.hokIcon.skin_list[this.hero_id].filter(
      (v) => v.skin_id == this.skin_id
    )[0].icon;
    this.skin_name = this.hokIcon.skin_list[this.hero_id].filter(
      (v) => v.skin_id == this.skin_id
    )[0].skin_name;
    this.hok_inside_api();
    this.hok_out_api();
    await this.deviceList_api();
    if (this.device_list?.length > 0) {
      this.device_in = this.device_list[0].id;
    } else {
      this.device_in = "";
    }
    if (this.device_out_list?.length > 0) {
      this.device_out = this.device_out_list[0].id;
    } else {
      this.device_out = "";
    }

    this.hok_in_trend();
    this.hok_out_trend();
  }
  public getSkin_icon_name() {
    this.skin_icon = this.hokIcon.skin_list[this.hero_id][0].icon;
    this.skin_name = this.hokIcon.skin_list[this.hero_id][0].skin_name;
    this.skin_id = this.hokIcon.skin_list[this.hero_id][0].skin_id;
  }
  public async hok_inside_api() {
    await dispatchGetHokIn(store, {
      project: this.localProject,
      skin_id: this.skin_id,
    });
    this.hokInSide();
    this.inside_loading = false;
  }
  public async hok_out_api() {
    await dispatchGetHokOut(store, {
      project: this.localProject,
      skin_id: this.skin_id,
    });
    this.hokInOut();
    this.out_loading = false;
  }
  public async deviceList_api() {
    await dispatchGetHokDeviceList(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      type: 4,
    });
    await dispatchGetHokDeviceOutList(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      type: 3,
    });
  }
  public async hok_in_trend() {
    await dispatchGetHokInSkinTrend(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      device_id: this.device_in,
      quality: this.device_list.filter((v) => v.id == this.device_in)[0]
        .quality,
    });
    this.drawInSide();
    this.inside_trend_loading = false;
  }
  public async hok_out_trend() {
    await dispatchGetHokOutSkinTrend(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      action: this.action,
      device_id: this.device_out,
      quality: this.device_out_list.filter((v) => v.id == this.device_out)[0]
        .quality,
    });
    this.drawOut();
    this.out_trend_loading = false;
  }
  public get name_img() {
    return readUserProfile(store).username;
  }
  public async mounted() {
    await dispatchGetHokIcon(store, {
      project: this.localProject,
    });
    this.inside_loading = true;
    this.out_loading = true;
    this.inside_trend_loading = true;
    this.out_trend_loading = true;

    this.hero_id = this.hokIcon.hero_list[0].hero_id;
    this.hero_name = this.hokIcon.hero_list[0].hero_name;
    this.target_index = this.target_types[0];
    this.target_index_out = this.target_types[0];
    this.action = this.kingAction[0].value;
    this.getSkin_icon_name();
    await this.deviceList_api();

    this.device_in = this.device_list[0].id;
    this.device_out = this.device_out_list[0].id;
    this.hok_inside_api();
    this.hok_out_api();
    this.hok_in_trend();
    this.hok_out_trend();

    // await dispatchGetHokOut(store,{
    //         project:this.localProject,
    // skin_id:this.skin_id
    // })
    // this.hokInOut()
  }
}
